/**
 * Utilidades para manejo de estados de registros Medifarma
 */

export type EstadoBadgeVariant = 'info' | 'success' | 'destructive' | 'warning' | 'outline' | 'secondary'

export function getEstadoBadgeVariant(estado: string): EstadoBadgeVariant {
  switch (estado) {
    case 'Pendiente':
      return 'warning'
    case 'En Proceso':
      return 'info'
    case 'Registrado':
      return 'success'
    case 'Cancelado':
      return 'destructive'
    default:
      return 'outline'
  }
}

export function getEstadoBadgeClass(estado: string): string {
  switch (estado) {
    case 'Registrado':
      return 'badge-gradient hover:opacity-90'
    case 'Pendiente':
      return 'badge-gradient-yellow hover:opacity-90'
    case 'En Proceso':
      return 'badge-gradient hover:opacity-90'
    case 'Cancelado':
      return 'bg-transparent border border-red-500 text-red-600 dark:text-red-400 shadow-none hover:opacity-90'
    default:
      return 'bg-transparent border border-gray-400 text-gray-500 dark:text-gray-400 shadow-none hover:opacity-90'
  }
}
